module.exports = __webpack_public_path__ + "static/bg-economy-8875cf14d04a756920cb69bfd2600c97.jpg";